webpackJsonp([2],{

/***/ "+7Hk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Chart__ = __webpack_require__("40sN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Chart__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Chart: __WEBPACK_IMPORTED_MODULE_0__Chart___default.a
  },
  data: function data() {
    return {
      types: [{ name: '道琼斯', code: 'dowi' }, { name: '纳斯达克', code: 'nasx' }, { name: '标普500', code: 'spx500' }]
    };
  }
});

/***/ }),

/***/ "+eoj":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.onClosePicker),
      expression: "onClosePicker"
    }],
    staticClass: "jin10-datepicker",
    class: {
      'picker-visible': _vm.datePickerPanelShow
    }
  }, [_c('span', {
    staticClass: "jin10-datepicker__input",
    on: {
      "click": _vm.handleTriggerDate
    }
  }, [_vm._v("\n    " + _vm._s(_vm.dateValueText) + "\n    "), _c('i', {
    staticClass: "ushk-icon ushk-icon_triangle"
  })]), _vm._v(" "), _c('span', {
    staticClass: "jin10-datepicker__input jin10-datepicker__mb-input",
    on: {
      "click": _vm.handleTriggerDate
    }
  }, [_vm._v("\n    " + _vm._s(_vm.mobileDateValueText) + "\n  ")]), _vm._v(" "), (_vm.notToday) ? _c('button', {
    staticClass: "jin10-datepicker__button",
    on: {
      "click": _vm.backToday
    }
  }, [_c('i', {
    staticClass: "ushk-icon ushk-icon_today"
  }), _vm._v("\n    回到今天\n  ")]) : _vm._e(), _vm._v(" "), _vm._t("right"), _vm._v(" "), _c('jin-date-picker-panel', {
    ref: "datePickerPanel",
    attrs: {
      "placement": "right",
      "initDate": _vm.value
    },
    on: {
      "pick": _vm.onDatePick,
      "open": _vm.onDatePickerOpen
    },
    model: {
      value: (_vm.datePickerPanelShow),
      callback: function($$v) {
        _vm.datePickerPanelShow = $$v
      },
      expression: "datePickerPanelShow"
    }
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ "+mDD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calendarHeaders; });

var calendarHeaders = {
  'x-version': '1.0.0',
  'x-app-id': 'BNsiR9uq7yfW0LVz'
};

/***/ }),

/***/ "/PmV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    border: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      rates: [],
      isShow: false
    };
  },
  mounted: function mounted() {
    this.getRates();
  },

  methods: {
    getRates: function getRates() {
      var _this = this;

      $.getJSON('https://rili.jin10.com/interest_rates.json').done(function (datas) {
        _this.rates = datas;
      });
    }
  }
});

/***/ }),

/***/ "/oiM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ "13m2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return requestUrl; });

var path = 'https://flash-api.ushknews.com/';
var proxy = path;

if (false) {
  proxy = '/api/';
}

var calendarProxy = 'https://calendar-api.ushknews.com/';
if (false) {
  calendarProxy = '/calendar-api/';
}

var requestUrl = {
  ucenterInfo: '//ucenter.jin10.com/info/',
  video: {
    getProxy: function getProxy(url) {
      var proxy =  false ? '//cdn.jin10.com/reading/uploads/' : '//cdn.jin10.com/reading/uploads/';
      return proxy + url;
    },
    list: function list(page, type) {
      return this.getProxy('video_list' + '.json') + '?v=' + new Date().getTime();
    },
    getEffect: function getEffect(id) {
      return this.getProxy(id + '/' + id + '_effect.jpeg');
    }
  },
  home: {
    flash: proxy + 'flash',
    company: proxy + 'company'
  },
  rili: {
    economics: calendarProxy + 'rili',
    stock: calendarProxy + 'rili?type=1',
    events: calendarProxy + 'events',
    holiday: calendarProxy + 'holidays',
    stockAffect: calendarProxy + 'web/api/stock_affect'
  }
};

/***/ }),

/***/ "2UWm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2hvf":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("7dKe")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  null,
  /* template */
  __webpack_require__("PZeC"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "40sN":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("RePM"),
  /* template */
  __webpack_require__("ijxf"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "6Tc7":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("BAM+")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("xbG2"),
  /* template */
  __webpack_require__("+eoj"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "7FAJ":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("v1S1"),
  /* template */
  __webpack_require__("nKiP"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "7dKe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Yka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getFirstDayOfMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getDayCountOfMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return prevDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return nextDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getStartDateOfMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getDateTimestamp; });
/* unused harmony export clearTime */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return modifyDate; });
/* unused harmony export changeYearMonthAndClampDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return prevMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return nextMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return prevYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return nextYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getWeekNumber; });
/* unused harmony export range */
/* unused harmony export getMonthDays */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getWeekOfMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getEndWeekOfLastMonth; });
/* unused harmony export getWeekOfMonthData */
/* unused harmony export getTimestamp */
/* harmony export (immutable) */ __webpack_exports__["o"] = getDayTimestamp;

var isDate = function isDate(date) {
  if (date === null || date === undefined) {
    return false;
  }
  if (isNaN(new Date(date).getTime())) {
    return false;
  }
  if (Array.isArray(date)) {
    return false;
  }
  return true;
};

var getFirstDayOfMonth = function getFirstDayOfMonth(date) {
  var temp = new Date(date.getTime());
  temp.setDate(1);
  return temp.getDay();
};

var getDayCountOfMonth = function getDayCountOfMonth(year, month) {
  if (month === 3 || month === 5 || month === 8 || month === 10) {
    return 30;
  }

  if (month === 1) {
    if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
      return 29;
    } else {
      return 28;
    }
  }

  return 31;
};

var prevDate = function prevDate(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - amount);
};

var nextDate = function nextDate(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
};

var getStartDateOfMonth = function getStartDateOfMonth(year, month) {
  var result = new Date(year, month, 1);
  var day = result.getDay();

  if (day === 0) {
    return prevDate(result, 7);
  } else {
    return prevDate(result, day);
  }
};

var getDateTimestamp = function getDateTimestamp(time) {
  if (typeof time === 'number' || typeof time === 'string') {
    return clearTime(new Date(time)).getTime();
  } else if (time instanceof Date) {
    return clearTime(time).getTime();
  } else {
    return NaN;
  }
};

var clearTime = function clearTime(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

var modifyDate = function modifyDate(date, y, m, d) {
  return new Date(y, m, d, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
};

var changeYearMonthAndClampDate = function changeYearMonthAndClampDate(date, year, month) {
  var monthDate = Math.min(date.getDate(), getDayCountOfMonth(year, month));
  return modifyDate(date, year, month, monthDate);
};

var prevMonth = function prevMonth(date) {
  var year = date.getFullYear();
  var month = date.getMonth();
  return month === 0 ? changeYearMonthAndClampDate(date, year - 1, 11) : changeYearMonthAndClampDate(date, year, month - 1);
};

var nextMonth = function nextMonth(date) {
  var year = date.getFullYear();
  var month = date.getMonth();
  return month === 11 ? changeYearMonthAndClampDate(date, year + 1, 0) : changeYearMonthAndClampDate(date, year, month + 1);
};

var prevYear = function prevYear(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var year = date.getFullYear();
  var month = date.getMonth();
  return changeYearMonthAndClampDate(date, year - amount, month);
};

var nextYear = function nextYear(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var year = date.getFullYear();
  var month = date.getMonth();
  return changeYearMonthAndClampDate(date, year + amount, month);
};

var getWeekNumber = function getWeekNumber(src) {
  if (!isDate(src)) {
    return null;
  }
  var date = new Date(src.getTime());
  date.setHours(0, 0, 0, 0);

  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);

  var week1 = new Date(date.getFullYear(), 0, 4);

  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
};

var range = function range(n) {
  return Array.apply(null, { length: n }).map(function (_, n) {
    return n;
  });
};

var getMonthDays = function getMonthDays(date) {
  var temp = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  var days = temp.getDate();
  return range(days).map(function (_, index) {
    return index + 1;
  });
};

var getWeekOfMonth = function getWeekOfMonth(date) {
  var firstDayOfMonth = getFirstDayOfMonth(date) || 7;

  var weekOfMonth = firstDayOfMonth === 1 ? Math.ceil(date.getDate() / 7) : Math.ceil((date.getDate() - (7 - firstDayOfMonth + 1)) / 7);
  return weekOfMonth;
};

var getEndWeekOfLastMonth = function getEndWeekOfLastMonth(date) {
  var firstDayOfMonth = getFirstDayOfMonth(date) || 7;

  var toMinus = 1 - firstDayOfMonth;
  var lastMonth = prevMonth(date);
  var lastMountDayCount = getDayCountOfMonth(lastMonth.getFullYear(), lastMonth.getMonth());
  var firstDayOfMonthOfLastMonth = getFirstDayOfMonth(lastMonth) || 7;
  var lastMonthEndStartDay = lastMountDayCount + toMinus + 1;

  var lastMonthEndWeek = firstDayOfMonthOfLastMonth === 1 ? Math.ceil(lastMonthEndStartDay / 7) : Math.ceil((lastMonthEndStartDay - (7 - firstDayOfMonthOfLastMonth + 1)) / 7);
  return lastMonthEndWeek;
};

var getWeekOfMonthData = function getWeekOfMonthData(date) {
  var weekOfMonth = getWeekOfMonth(date);
  return {
    date: date,
    showDate: weekOfMonth <= 0 ? prevMonth(date) : date,
    order: weekOfMonth <= 0 ? getEndWeekOfLastMonth(date) : weekOfMonth,
    month: weekOfMonth <= 0 ? prevMonth(date).getMonth() : date.getMonth(),
    isLastMonthWeek: weekOfMonth <= 0
  };
};

var getTimestamp = function getTimestamp(datetime, type) {
  var time = new Date(datetime);
  if (type === 'day') {
    time.setHours(0);
    time.setMinutes(0);
  }
  time.setSeconds(0);
  time.setMilliseconds(0);
  return time.getTime();
};

function getDayTimestamp(datetime) {
  return getTimestamp(datetime, 'day');
}

/***/ }),

/***/ "AmHV":
/***/ (function(module, exports) {


window.Date.prototype.format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    S: this.getMilliseconds() };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

/***/ }),

/***/ "BAM+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BOTu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BW5Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__ = __webpack_require__("8Yka");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JinMonthTable__ = __webpack_require__("HHpQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JinMonthTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JinMonthTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JinDateTable__ = __webpack_require__("ha5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JinDateTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JinDateTable__);






var DATE_FORMATS = {
  day: 'yyyy-MM-dd',
  week: 'yyyy-MM',
  month: 'yyyy-MM'
};

var WEEK_ORDERS = ['一', '二', '三', '四', '五'];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'JinDatePickerPanel',

  model: {
    prop: 'visible',
    event: 'change'
  },
  components: {
    JinMonthTable: __WEBPACK_IMPORTED_MODULE_1__JinMonthTable___default.a,
    JinDateTable: __WEBPACK_IMPORTED_MODULE_2__JinDateTable___default.a
  },
  props: {
    initDate: {
      type: Date,
      default: function _default() {
        return this.date;
      }
    },
    placement: {
      type: String,
      default: 'left'
    },
    visible: Boolean,
    hideAfterSubmit: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    var _this = this;

    return {
      actualCurrentYear: new Date().getFullYear(),
      firstDayOfWeek: 1,
      value: '',
      date: new Date(),
      selectionMode: 'day',
      shortcuts: [{
        text: '本周',
        type: 'week',
        shortcut: 'currentWeek',
        onClick: function onClick() {
          _this.handleShortcutClick('currentWeek');
        }
      }, {
        text: '上周',
        type: 'week',
        shortcut: 'lastWeek',
        onClick: function onClick() {
          _this.handleShortcutClick('lastWeek');
        }
      }, {
        text: '下周',
        type: 'week',
        shortcut: 'nextWeek',
        onClick: function onClick() {
          _this.handleShortcutClick('nextWeek');
        }
      }, {
        text: '本月',
        type: 'month',
        shortcut: 'currentMonth',
        onClick: function onClick() {
          _this.handleShortcutClick('currentMonth');
        }
      }, {
        text: '上月',
        type: 'month',
        shortcut: 'lastMonth',
        onClick: function onClick() {
          _this.handleShortcutClick('lastMonth');
        }
      }, {
        text: '下月',
        type: 'month',
        shortcut: 'nextMonth',
        onClick: function onClick() {
          _this.handleShortcutClick('nextMonth');
        }
      }],
      ranges: [{
        label: '月',
        value: 'month',
        onClick: function onClick() {
          _this.showMonthPicker();
        }
      }, {
        label: '周',
        value: 'week',
        onClick: function onClick() {
          _this.showWeekPicker();
        }
      }, {
        label: '日',
        value: 'day',
        onClick: function onClick() {
          _this.showDayPicker();
        }
      }]
    };
  },

  computed: {
    offsetDay: function offsetDay() {
      var week = this.firstDayOfWeek;

      return week > 3 ? 7 - week : -week;
    },
    year: function year() {
      return this.date.getFullYear();
    },
    month: function month() {
      return this.date.getMonth();
    },
    day: function day() {
      return this.date.getDate();
    },
    week: function week() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["a" /* getWeekNumber */])(this.date);
    },
    yearLabel: function yearLabel() {
      return this.year + '年';
    },
    monthLabel: function monthLabel() {
      var month = this.month;

      return String(month + 1).length < 2 ? '0' + (month + 1) + '\u6708' : month + 1 + '\u6708';
    },
    dayLabel: function dayLabel() {
      var day = this.day;

      return String(day + 1).length < 2 ? '0' + day + '\u65E5' : day + '\u65E5';
    },
    backToCurrentLabel: function backToCurrentLabel() {
      return {
        day: '回到今日',
        week: '回到本周',
        month: '回到本月'
      }[this.selectionMode];
    },
    actualMonth: function actualMonth() {
      return new Date().getMonth();
    }
  },
  methods: {
    onChangeMonth: function onChangeMonth(month) {
      if (month === 1) {
        this.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["b" /* nextMonth */])(new Date(this.year - 1 + '/12/' + this.day));
        return;
      }

      this.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["b" /* nextMonth */])(new Date(this.year + '/' + (month - 1) + '/' + this.day));
    },
    show: function show() {
      this.$emit('change', true);
    },
    hide: function hide() {
      this.$emit('change', false);
    },
    showMonthPicker: function showMonthPicker() {
      this.selectionMode = 'month';
    },
    showWeekPicker: function showWeekPicker() {
      this.selectionMode = 'week';
    },
    showDayPicker: function showDayPicker() {
      this.selectionMode = 'day';
    },
    prevYear: function prevYear() {
      this.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["c" /* prevYear */])(this.date);
    },
    nextYear: function nextYear() {
      this.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["d" /* nextYear */])(this.date);
    },
    prevMonth: function prevMonth() {
      this.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["e" /* prevMonth */])(this.date);
    },
    nextMonth: function nextMonth() {
      this.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["b" /* nextMonth */])(this.date);
    },
    handleMonthPick: function handleMonthPick(month) {
      this.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["f" /* modifyDate */])(this.date, this.year, month, 1);
      this.handleSubmit();
    },
    handleDatePick: function handleDatePick(value) {
      this.date = new Date(value);
      this.handleSubmit();
    },
    handleBackToCurrent: function handleBackToCurrent() {
      this.date = new Date();
      this.handleSubmit();
    },
    handleShortcutClick: function handleShortcutClick(shortcut) {
      var _this2 = this;

      var currentDate = new Date();
      var handler = {
        currentWeek: function currentWeek() {
          _this2.selectionMode = 'week';
          _this2.date = currentDate;
        },
        lastWeek: function lastWeek() {
          _this2.selectionMode = 'week';
          _this2.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["g" /* prevDate */])(currentDate, 7);
        },
        nextWeek: function nextWeek() {
          _this2.selectionMode = 'week';
          _this2.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["h" /* nextDate */])(currentDate, 7);
        },
        currentMonth: function currentMonth() {
          _this2.selectionMode = 'month';
          _this2.date = currentDate;
        },
        lastMonth: function lastMonth() {
          _this2.selectionMode = 'month';
          _this2.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["e" /* prevMonth */])(currentDate);
        },
        nextMonth: function nextMonth() {
          _this2.selectionMode = 'month';
          _this2.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["b" /* nextMonth */])(currentDate);
        }
      }[shortcut];
      handler && handler();
      this.$nextTick(function () {
        _this2.handleSubmit();
      });
    },
    getShortcutActive: function getShortcutActive(_ref) {
      var _this3 = this;

      var shortcut = _ref.shortcut,
          type = _ref.type;

      if (this.selectionMode !== type) {
        return false;
      }
      var currentDate = new Date();
      var _currentMonth = currentDate.getMonth();
      var currentYear = currentDate.getFullYear();
      var valid = {
        currentWeek: function currentWeek() {
          return _this3.week === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["a" /* getWeekNumber */])(currentDate) && _this3.year === currentYear;
        },
        lastWeek: function lastWeek() {
          return _this3.week === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["a" /* getWeekNumber */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["g" /* prevDate */])(currentDate, 7)) && _this3.year === currentYear;
        },
        nextWeek: function nextWeek() {
          return _this3.week === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["a" /* getWeekNumber */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["h" /* nextDate */])(currentDate, 7)) && _this3.year === currentYear;
        },
        currentMonth: function currentMonth() {
          return _this3.month === _currentMonth && _this3.year === currentYear;
        },
        lastMonth: function lastMonth() {
          return _currentMonth === 0 ? _this3.month === 11 && _this3.year === currentYear - 1 : _this3.month === _currentMonth - 1 && _this3.year === currentYear;
        },
        nextMonth: function nextMonth() {
          return _currentMonth === 11 ? _this3.month === 0 && _this3.year === currentYear + 1 : _this3.month === _currentMonth + 1 && _this3.year === currentYear;
        }
      }[shortcut];
      return valid();
    },
    handleSubmit: function handleSubmit() {
      var weekDays = [];
      if (this.selectionMode === 'week') {
        var weekDay = this.date.getDay();
        var weekStartDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["g" /* prevDate */])(this.date, weekDay === 0 ? 6 : weekDay - 1);
        for (var i = 0; i < 7; i++) {
          weekDays.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["h" /* nextDate */])(weekStartDate, i));
        }
      }

      var weekOfMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["i" /* getWeekOfMonth */])(this.date);

      var lastMonthEndWeek = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["j" /* getEndWeekOfLastMonth */])(this.date);
      var weekOfMonthObj = {
        date: weekOfMonth <= 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["e" /* prevMonth */])(this.date) : this.date,
        order: weekOfMonth <= 0 ? lastMonthEndWeek : weekOfMonth,
        month: weekOfMonth <= 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["e" /* prevMonth */])(this.date).getMonth() : this.month
      };
      var date = this.date;

      var label = {
        day: function day() {
          return date.format(DATE_FORMATS.day);
        },
        week: function week() {
          return weekOfMonthObj.date.format(DATE_FORMATS.week) + ' \u7B2C' + WEEK_ORDERS[weekOfMonthObj.order - 1] + '\u5468';
        },
        month: function month() {
          return date.format(DATE_FORMATS.month);
        }
      }[this.selectionMode]();
      var value = {
        week: this.week,
        year: this.year,
        month: this.month,
        date: this.date,
        mode: this.selectionMode,
        weekDays: weekDays,
        weekOfMonth: weekOfMonthObj,
        label: label
      };
      this.hideAfterSubmit && this.hide();
      this.$emit('pick', value);
    },
    setSelectionMode: function setSelectionMode(mode) {
      this.selectionMode = mode;
    },
    setDate: function setDate(date) {
      this.date = date;
    },
    pick: function pick() {
      this.handleSubmit();
    },
    beforeEnter: function beforeEnter() {
      this.$emit('open');
    },
    afterLeave: function afterLeave() {
      this.$emit('closed');
    }
  }
});

/***/ }),

/***/ "CBJG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    width: [String, Number],
    tagName: {
      type: String,
      default: 'div'
    }
  }
});

/***/ }),

/***/ "CJMA":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "jin-date-table",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.WEEKS), function(w) {
    return _c('th', {
      key: w
    }, [_vm._v("\n        " + _vm._s(w) + "\n      ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row, key) {
    return _c('tr', {
      key: key,
      staticClass: "jin-date-table__row"
    }, _vm._l((row), function(cell, ckey) {
      return _c('td', {
        key: ckey,
        class: _vm.getCellClasses(cell)
      }, [_c('div', [_c('span', {
        attrs: {
          "data-type": cell.type
        }
      }, [_vm._v("\n            " + _vm._s(cell.text) + "\n          ")])])])
    }), 0)
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ "DfDl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RELEASE_VERSION */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters__ = __webpack_require__("Q0Ca");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_commons_scss__ = __webpack_require__("fTYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_commons_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_commons_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css__ = __webpack_require__("v2ns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_index__ = __webpack_require__("AmHV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__plugins_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_clickoutside__ = __webpack_require__("pNk6");








var RELEASE_VERSION = 'release_v1.0.0';

window.console.log('version: ' + RELEASE_VERSION);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3__filters__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive('click-outside', __WEBPACK_IMPORTED_MODULE_7__directives_clickoutside__["a" /* default */]);

/***/ }),

/***/ "E/y/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EiBX":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("2UWm")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("s+38"),
  /* template */
  __webpack_require__("eA1R"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e83991b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "FnhZ":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("k+4S")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("/oiM"),
  /* template */
  __webpack_require__("uKUY"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4d534e6f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "HCTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_utils__ = __webpack_require__("j+bc");



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UshkHeader',
  props: {
    showDesc: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      menus: [{
        type: 'news',
        name: '首页',
        url: '//www.ushknews.com'
      }, {
        type: 'calendar',
        name: '日历',
        url: '//www.ushknews.com/calendar.html'
      }, {
        type: 'report',
        name: '投行报告',
        url: '//www.ushknews.com/report.html'
      }, {
        type: 'app',
        name: '下载APP',
        url: '//www.ushknews.com/app/index.html'
      }],
      isPcFlag: false,
      showNav: false
    };
  },


  components: {},
  methods: {
    setActiveState: function setActiveState(type) {
      var href = window.location.href;
      if (type === 'news' && href.indexOf('index.html') !== -1 || type === 'news' && href.indexOf('.html') === -1) {
        return true;
      }
      return href.indexOf(type + '.html') !== -1;
    },
    isPcFun: function isPcFun() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils__["f" /* isPC */])()) {
        this.isPcFlag = true;
        this.showNav = true;
      } else {
        this.isPcFlag = false;
        this.showNav = false;
      }
    },
    switchNav: function switchNav() {
      this.showNav = !this.showNav;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.isPcFun();
    var _this = this;

    window.addEventListener('resize', function () {
      _this.isPcFun();
    });
  },

  watch: {}
});

/***/ }),

/***/ "HHpQ":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("wY0R")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Suwc"),
  /* template */
  __webpack_require__("ZeX0"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ad21e5f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "J+Zw":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("diRV")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("BW5Q"),
  /* template */
  __webpack_require__("N2CP"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23c8991e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Kc2c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_utils__ = __webpack_require__("j+bc");



function isWechat() {
  var ua = window.navigator.userAgent.toLowerCase();

  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

var wechatShareConfig = function wechatShareConfig(options) {

  if (!isWechat()) {
    return;
  }
  var jssdk = '//res.wx.qq.com/open/js/jweixin-1.2.0.js';
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_fetch__["a" /* fetch */])({
    url: '//news-d.jin10.com/sign',
    params: {
      url: location.href
    },
    type: 'jsonp',
    jsonpCallback: 'jsonpCallback',
    success: function success(response) {
      var data = response.data;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__commons_utils__["a" /* addScript */])(jssdk, function () {
        wx.config({
          debug: false,
          appId: 'wx4cbb30b2fd83dd88',
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
        });

        var url = document.location.href;
        wx.ready(function () {
          wx.onMenuShareTimeline({
            title: options.title,
            link: url,
            imgUrl: options.imgUrl,
            success: function success() {},
            cancel: function cancel() {}
          });
          wx.onMenuShareAppMessage({
            title: options.title,
            desc: options.desc,
            link: url,
            imgUrl: options.imgUrl,
            type: 'link',
            dataUrl: '',
            success: function success() {},
            cancel: function cancel() {}
          });

          wx.error(function (res) {});
        });
      });
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (wechatShareConfig);

/***/ }),

/***/ "Kg+A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var prefixCls = 'ushk-icon';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Icon',
  props: {
    type: String,
    size: [Number, String],
    color: String
  },
  computed: {
    classes: function classes() {
      return prefixCls + ' ' + prefixCls + '_' + this.type;
    },
    styles: function styles() {
      var style = {};

      if (this.size) {
        style['font-size'] = this.size + 'px';
      }

      if (this.color) {
        style.color = this.color;
      }

      return style;
    }
  }
});

/***/ }),

/***/ "N2CP":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-transform"
    },
    on: {
      "after-leave": _vm.afterLeave,
      "before-enter": _vm.beforeEnter
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "jin-picker-panel",
    class: [("placement-" + _vm.placement)],
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "jin-picker-panel__body"
  }, [_c('div', {
    staticClass: "jin-date-picker__header"
  }, [_c('div', {
    staticClass: "jin-date-picker__toggle"
  }, [_c('button', {
    staticClass: "jin-date-picker__prev-btn jin-picker-panel__icon-btn",
    on: {
      "click": _vm.prevYear
    }
  }, [_c('span', {
    staticClass: "ushk-icon ushk-icon_triangle"
  })]), _vm._v(" "), _c('span', {
    staticClass: "jin-date-picker__header-label"
  }, [_vm._v("\n            " + _vm._s(_vm.yearLabel) + "\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "jin-date-picker__header-label"
  }, [_vm._v("\n            " + _vm._s(_vm.monthLabel) + "\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "jin-date-picker__header-label"
  }, [_vm._v("\n            " + _vm._s(_vm.dayLabel) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "jin-date-picker__next-btn jin-picker-panel__icon-btn",
    on: {
      "click": _vm.nextYear
    }
  }, [_c('span', {
    staticClass: "ushk-icon ushk-icon_triangle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "jin-picker-panel__content"
  }, [_c('jin-date-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectionMode === 'day' || _vm.selectionMode === 'week'),
      expression: "selectionMode === 'day' || selectionMode === 'week'"
    }],
    attrs: {
      "date": _vm.date,
      "initDate": _vm.initDate,
      "selection-mode": _vm.selectionMode,
      "first-day-of-week": _vm.firstDayOfWeek
    },
    on: {
      "pick": _vm.handleDatePick
    }
  }), _vm._v(" "), _c('jin-month-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectionMode === 'month'),
      expression: "selectionMode === 'month'"
    }],
    attrs: {
      "date": _vm.date,
      "selection-mode": _vm.selectionMode
    },
    on: {
      "pick": _vm.handleMonthPick
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jin-picker-panel__footer"
  }, [_c('div', {
    staticClass: "jin-picker-panel__months"
  }, _vm._l((12), function(i) {
    return _c('span', {
      key: i,
      class: {
        active: i === _vm.month + 1,
          current: i === _vm.actualMonth + 1 && _vm.actualCurrentYear === _vm.year
      },
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          $event.stopPropagation();
          return _vm.onChangeMonth(i)
        }
      }
    }, [_vm._v("\n          " + _vm._s(i) + "月\n        ")])
  }), 0)])])])
},staticRenderFns: []}

/***/ }),

/***/ "N4+L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return showLoginBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return device; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("j+bc");




var w = window;
if (!w['console']) {
  var newConsole = {};
  w.console = {};
  var forObj = function forObj(obj) {
    var forHtml = '';
    if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) === 'object') {
      for (var i in obj) {
        forHtml += '{' + i + ':' + forObj(obj[i]) + '}';
      }
    } else {
      forHtml = obj;
    }
    return forHtml;
  };
  newConsole.log = function (msg) {
    var body = document.getElementsByTagName('body')[0];
    var newChild = document.createElement('consoleNode');
    var newMsg = 'error';
    if (typeof msg === 'string') {
      newMsg = msg;
    } else if ((typeof msg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(msg)) === 'object') {
      newMsg = '';
      newMsg = forObj(msg);
    }
    newChild.style.display = 'none';
    newChild.innerText = newMsg;
    body.appendChild(newChild);
  };
  w.console = newConsole;
}

var ucenterUI = null;
var showLoginBox = function showLoginBox(_ref) {
  var embedded = _ref.embedded,
      _loginCallback = _ref.loginCallback,
      _oauthCallback = _ref.oauthCallback,
      type = _ref.type;

  type = type || '';
  var init = function init() {
    if (!ucenterUI) {
      ucenterUI = new UCenterUI({
        embedded: embedded,
        loginCallback: function loginCallback(json) {
          ucenterUI.userModal.hide(1000);
          _loginCallback(json);
        },
        oauthCallback: function oauthCallback(json) {
          ucenterUI.userModal.hide(1000);
          _oauthCallback();
        }
      });
    }
    ucenterUI.userModal.show(type);
    if (type === 'register') {
      ucenterUI.userModal.userModal_register.find('.J_imgCaptcha').trigger('click');
    }
  };
  if (typeof UCenterUI === 'undefined') {
    loadUCenterUI().then(function () {
      init();
    });
  } else {
    init();
  }
};

function loadUCenterUI() {
  var url = {
    jquery: '//cdn.jin10.com/assets/js/libs/jquery-1.11.1.min.js',
    rsa: '//cdn.jin10.com/assets/js/plugins/rsa.js',
    ucenterUI: '//cdn.jin10.com/assets/js/ucenterUI/main.js',
    css: '//cdn.jin10.com/assets/css/ucenterUI.css'
  };
  var ucenterUI = function ucenterUI(cb) {
    if (typeof UCenterUI !== 'undefined') {
      cb();
      return false;
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* addScript */])(url.rsa, function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* addScript */])(url.ucenterUI, function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* addCss */])(url.css).then(function () {
          cb();
        });
      });
    });
  };
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (!window.$ && !window.jQuery) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* addScript */])(url.jquery, function () {
        ucenterUI(resolve);
      });
    } else {
      ucenterUI(resolve);
    }
  });
}

var device = function () {
  var ua = navigator.userAgent;
  var isAndroid = /Android\s+([\d.]+)/.test(ua);
  var isIos = /(?:iPad|iPhone).*OS\s([\d_]+)/.test(ua) && !isAndroid;
  var isMobile = isAndroid || isIos;
  var isWeixin = /micromessenger/.test(ua.toLowerCase());
  var isQQ = /QQBrowser/.test(ua);
  var isChrome = ua.toLowerCase().indexOf('chrome') > -1;
  return {
    isAndroid: isAndroid,
    isIos: isIos,
    isMobile: isAndroid || isIos,
    isWeixin: isWeixin,
    isQQ: isQQ,
    isChrome: isChrome
  };
}();

/***/ }),

/***/ "OChx":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("CBJG"),
  /* template */
  __webpack_require__("ZfbR"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "OQfM":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("+7Hk"),
  /* template */
  __webpack_require__("eORg"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "PZeC":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-declaration"
  }, [_c('div', {
    staticClass: "jin-declaration_title"
  }, [_c('h5', [_c('i'), _vm._v(" "), _c('span', [_vm._v("美港电讯声明")])])]), _vm._v(" "), _c('div', {
    staticClass: "jin-declaration_b"
  }, [_c('p', [_vm._v("\n      美港电讯的数据解读是计算机自动获取并通过程序运算进行的理论性解读，不代表实际影响。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      我们会尽力保证数据发布速度与准确性，由于不可控因素导致数据未能及时发布敬请谅解。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      您或许看到有些数据延迟或提前发布，这是由于数据公布机构有时未必会准时发布所导致。\n    ")])])])
}]}

/***/ }),

/***/ "Q0Ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dateFormat__ = __webpack_require__("i2vQ");



var filters = {
  dateFormat: __WEBPACK_IMPORTED_MODULE_1__dateFormat__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).forEach(function (name) {
    Vue.filter(name, filters[name]);
  });
});

/***/ }),

/***/ "RC9X":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-footer"
  }, [_c('div', {
    staticClass: "ushk-wrap ushk-wrap-main"
  }, [_c('div', {
    staticClass: "ushk-footer__wrap"
  }, [_c('div', {
    staticClass: "ushk-footer__l ushk-footer__link"
  }, [_c('dl', _vm._l((_vm.links), function(item) {
    return _c('dd', {
      key: item.name
    }, [_c('a', {
      attrs: {
        "href": item.link ? item.link : '#',
        "target": item.link ? '_blank' : ''
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "app-info"
  }, [_vm._l((_vm.appInfo), function(item) {
    return _c('span', [_vm._v(_vm._s(item.label))])
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./permissions.html",
      "target": "_blank"
    }
  }, [_vm._v("权限详情")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.ushknews.com/app_pages/privacy_agreement.html",
      "target": "_blank"
    }
  }, [_vm._v("隐私协议")])], 2)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "ushk-footer__wrap"
  }, [_c('div', {
    staticClass: "ushk-footer__r ushk-footer__renzheng"
  }, [_vm._l((_vm.certifications), function(item, index) {
    return _c('p', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "width": "48",
        "height": "20",
        "src": item.img,
        "srcset": item.img2x + ' 2x'
      }
    })])])
  }), _vm._v(" "), _vm._m(1)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-footer__r ushk-footer__copyright"
  }, [_c('p', [_vm._v("金十数据 广州金十信息科技有限公司 版权所有\n        ")]), _vm._v(" "), _c('p', [_vm._v("Copyright © 2013 - 现在 Jin10.com All Rights Reserved")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "http://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备16010774号-5")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010502002893",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": "https://cdn.jin10.com/assets/img/commons/gonganbeian.png",
      "alt": "",
      "width": "13"
    }
  }), _vm._v("\n            粤公网安备44010502002893号\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-footer__counselor"
  }, [_c('i', {
    staticClass: "ushk-icon ushk-icon_counselor"
  }), _vm._v(" "), _c('span', [_vm._v("常年法律顾问：广东踔厉律师事务所")])])
}]}

/***/ }),

/***/ "RePM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_utils__ = __webpack_require__("j+bc");





/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: {
    name: String,
    code: String
  },
  data: function data() {
    return {
      isLoading: false,
      isEmpty: true
    };
  },
  created: function created() {
    var _this = this;

    this.render();
    setInterval(function () {
      _this.render();
    }, 30000);
  },

  methods: {
    render: function render() {
      var _this2 = this;

      this.getData().then(function (datas) {
        _this2.creatChart(datas);
      });
    },
    getData: function getData() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.isLoading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__commons_fetch__["a" /* fetch */])({
          url: '//chart.jin10.com/baojia.php',
          params: {
            type: _this3.code
          },
          showError: false,
          type: 'jsonp',
          jsonpCallback: 'jsonpcallback',
          callback: function callback(res) {
            _this3.isLoading = false;
            var datas = [];
            var l = res && res.length;
            if (!l) {
              return false;
            }
            _this3.isEmpty = false;
            for (var i = 0; i < l; i++) {
              datas.push({
                name: res[i][0],
                value: res[i]
              });
            }
            resolve(datas);
          },
          error: function error() {
            _this3.isLoading = false;
          }
        });
      });
    },
    creatChart: function creatChart(datas) {
      var _this4 = this;

      var option = {
        grid: {
          top: '5%',
          left: '0%',
          width: '80%',
          height: '90%',
          show: true,
          backgroundColor: '#fff'
        },
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              width: 0
            }
          },
          backgroundColor: 'rgba(244,244,244, 0.8)',
          padding: [5, 10],
          formatter: function formatter(params) {
            var value = params[0].value;
            return '<div class="ushk-chart-tips"><div class="ushk-chart-tips__num">当前价格：<span>' + value[1] + '</span></div><div class="ushk-chart-tips__time">' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_utils__["c" /* dateFormat */])(new Date(value[0]), 'yyyy-MM-dd hh:mm') + '</div></div>';
          }
        },
        xAxis: {
          type: 'time',
          boundaryGap: true,
          splitLine: {
            show: true,
            interval: 'auto',
            lineStyle: {
              color: ['#f1f1f1']
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#d4d1d2'
            }
          },
          axisLabel: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          position: 'right',
          scale: true,
          boundaryGap: true,
          splitLine: {
            lineStyle: {
              color: ['#f1f1f1']
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#d4d1d2'
            }
          },
          axisLabel: {
            margin: 10,

            textStyle: {
              fontSize: 12
            }
          }
        },
        series: [{
          name: '当前价格',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            normal: {
              color: '#f45b42'
            }
          },
          lineStyle: {
            normal: {
              width: 1
            }
          },
          animation: false,
          animationDuration: 200,
          data: datas
        }]
      };
      var init = function init() {
        var chart = echarts.init(_this4.$refs.chartBody);
        chart.setOption(option);
      };
      if (typeof echarts === 'undefined') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_utils__["a" /* addScript */])('//cdn.jin10.com/assets/js/plugins/echarts/echarts3.min.js?20170506', function () {
          init();
        });
      } else {
        init();
      }
    }
  }
});

/***/ }),

/***/ "Suwc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'JinMonthTable',
  props: {
    date: {}
  },
  data: function data() {
    return {
      tableRows: [[1, 2, 3, 4, 5, 6], [7, 8, 9, 10, 11, 12]]
    };
  },

  computed: {
    month: function month() {
      return this.date.getMonth();
    }
  },
  methods: {}
});

/***/ }),

/***/ "TVmP":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("UthT"),
  /* template */
  __webpack_require__("RC9X"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "UthT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isVideoPlaying'])),
  data: function data() {
    return {
      links: [{
        name: '下载APP',
        link: 'https://www.ushknews.com/app/index.html'
      }, {
        name: '联系我们',
        link: 'https://www.jin10.com/about/index.html#contact'
      }, {
        name: '广告合作',
        link: 'https://www.jin10.com/about/index.html#cooperation'
      }, {
        name: '数据引用',
        link: 'http://south.jin10.com/example/websiteiframe.html'
      }, {
        name: '人才招聘',
        link: 'https://jobs.jin10.com/#/'
      }, {
        name: '意见反馈',
        link: 'http://crm2.qq.com/page/portalpage/wpa.php?uin=800185710&cref=https%3A%2F%2Fid.b.qq.com%2Fcrm%2Findex.php%3Frr%3Dwpa&ref=https%3A%2F%2Fid.b.qq.com%2Fcrm%2Findex.php%3Frr%3Dwpa%2Fstyle%26id%3Dwpa_setting_a01&pt=undefined&f=1&ty=1&ap=&as=&aty=0&a='
      }, {
        name: '版权声明',
        link: 'https://www.jin10.com/about/index.html#privacy'
      }],
      certifications: [{
        img: __webpack_require__("qNZ7"),
        img2x: __webpack_require__("0+am"),
        link: 'http://v.pinpaibao.com.cn/authenticate/cert/?site=www.jin10.com&at=business'
      }, {
        img: __webpack_require__("feRo"),
        img2x: __webpack_require__("wTUH"),
        link: 'http://si.trustutn.org/info?sn=142160203020335292461&certType=1'
      }, {
        img: __webpack_require__("Uq1x"),
        img2x: __webpack_require__("gBM3"),
        link: '//www.jin10.com/knet.html'
      }],
      appInfo: [{
        label: '应用名称：美港电讯'
      }, {
        label: '应用版本：1.8.0'
      }, {
        label: '开发者：广州金十信息科技有限公司'
      }, {
        label: '更改时间：2021.05.21'
      }]
    };
  }
});

/***/ }),

/***/ "Vx3l":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-info jin-rili_rate"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "jin-info_b",
    class: {
      'hide-border': !_vm.border
    }
  }, [_c('div', {
    staticClass: "jin-rili_rate-wrap"
  }, [_c('table', {
    staticClass: "jin-table_body"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.rates), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('img', {
      attrs: {
        "width": "24",
        "height": "16",
        "src": item.flagImgUrl
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.bankName))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.interestRate) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.publishTime))])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-info_title"
  }, [_c('h5', [_c('i', {
    staticClass: "ushk-icon ushk-icon_zhexiantu"
  }), _vm._v(" "), _c('span', [_vm._v("各国/地区央行利率")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('b', [_vm._v("央 行")])]), _vm._v(" "), _c('th', [_c('b', [_vm._v("利 率")])]), _vm._v(" "), _c('th', [_c('b', [_vm._v("发布日期")])])])])
}]}

/***/ }),

/***/ "WCZ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon_vue__ = __webpack_require__("zmdZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__icon_vue__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__icon_vue___default.a);

/***/ }),

/***/ "ZeX0":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "jin-month-table"
  }, [_c('tbody', _vm._l((_vm.tableRows), function(row, key) {
    return _c('tr', {
      key: key
    }, _vm._l((row), function(cell) {
      return _c('td', {
        key: cell
      }, [_c('div', {
        class: {
          'current': cell === _vm.month + 1
        },
        on: {
          "click": function($event) {
            return _vm.$emit('pick', cell - 1)
          }
        }
      }, [_vm._v("\n          " + _vm._s(cell) + "月\n        ")])])
    }), 0)
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ "ZfbR":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.tagName, {
    tag: "component",
    staticClass: "ushk-star"
  }, [_c('i', {
    staticClass: "ushk-star_active",
    class: {
      'ushk-star_important': _vm.width > 2
    },
    style: ({
      width: ((_vm.width * 20) + "%")
    })
  })])
},staticRenderFns: []}

/***/ }),

/***/ "aehN":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: _vm.classes,
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),

/***/ "bGai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Footer__ = __webpack_require__("TVmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon__ = __webpack_require__("WCZ4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChartGroup__ = __webpack_require__("OQfM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChartGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ChartGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Star__ = __webpack_require__("OChx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Star___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Star__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Backtop__ = __webpack_require__("7FAJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Backtop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Backtop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Rate__ = __webpack_require__("x+d9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Rate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Rate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Declatration__ = __webpack_require__("2hvf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Declatration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Declatration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Ad__ = __webpack_require__("EiBX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Ad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Ad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Contact__ = __webpack_require__("FnhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DatePicker__ = __webpack_require__("6Tc7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__DatePicker__);













var components = {
  UshkHeader: __WEBPACK_IMPORTED_MODULE_1__Header___default.a,
  UshkFooter: __WEBPACK_IMPORTED_MODULE_2__Footer___default.a,
  Icon: __WEBPACK_IMPORTED_MODULE_3__Icon__["a" /* default */],
  ChartGroup: __WEBPACK_IMPORTED_MODULE_4__ChartGroup___default.a,
  Star: __WEBPACK_IMPORTED_MODULE_5__Star___default.a,
  Backtop: __WEBPACK_IMPORTED_MODULE_6__Backtop___default.a,
  Rate: __WEBPACK_IMPORTED_MODULE_7__Rate___default.a,
  Declatration: __WEBPACK_IMPORTED_MODULE_8__Declatration___default.a,
  UshkDatePicker: __WEBPACK_IMPORTED_MODULE_11__DatePicker___default.a,
  Ad: __WEBPACK_IMPORTED_MODULE_9__Ad___default.a,
  Contract: __WEBPACK_IMPORTED_MODULE_10__Contact___default.a
};

function install(Vue) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(components).forEach(function (key) {
    Vue.component(key, components[key]);
  });
}

/***/ }),

/***/ "d1Y1":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-header"
  }, [_c('div', {
    staticClass: "ushk-header__box"
  }, [_c('div', {
    staticClass: "ushk-wrap ushk-wrap-main"
  }, [_c('div', {
    staticClass: "ushk-header__wrap"
  }, [_vm._m(0), _vm._v(" "), (!_vm.isPcFlag) ? _c('div', {
    staticClass: "ushk-header__r"
  }, [_c('div', {
    class: ['ushk-header__btn', {
      'ushk-header__close': _vm.showNav
    }],
    on: {
      "click": _vm.switchNav
    }
  }, [_c('span')]), _vm._v(" "), _vm._l((_vm.menus), function(menu) {
    return (_vm.setActiveState(menu.type)) ? _c('div', {
      staticClass: "ushk-header__act"
    }, [_vm._v("\n            " + _vm._s(menu.name) + "\n          ")]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showDesc) ? _c('div', {
    staticClass: "ushk-header__f"
  }, [_vm._v("投资，快人一步")]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showNav) ? _c('div', {
    staticClass: "ushk-header__b"
  }, [_c('ul', {
    staticClass: "ushk-header-nav"
  }, _vm._l((_vm.menus), function(menu) {
    return _c('li', {
      staticClass: "ushk-header-nav__item",
      class: [
        ("ushk-header-nav__" + (menu.type)),
        {
          'is-active': _vm.setActiveState(menu.type)
        } ]
    }, [_c('a', {
      attrs: {
        "href": menu.url
      }
    }, [_c('span', [_vm._v(_vm._s(menu.name))])])])
  }), 0)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "ushk-header__slot"
  }, [_vm._t("default")], 2)])]), _vm._v(" "), (_vm.showNav && !_vm.isPcFlag) ? _c('div', {
    staticClass: "ushk-header__fixbg",
    on: {
      "click": _vm.switchNav
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-header__h"
  }, [_c('a', {
    attrs: {
      "href": "//www.ushknews.com"
    }
  }, [_c('h1', {
    staticClass: "ushk-header__logo"
  }, [_vm._v("美港电讯")])])])
}]}

/***/ }),

/***/ "diRV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eA1R":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.length || _vm.data.length === 1 && _vm.data[0]),
      expression: "data.length || data.length === 1 && data[0]"
    }],
    staticClass: "qrcode-view",
    class: [_vm.paddingTop ? 'qrcode-view-top' : '']
  }, [(_vm.data.length > 1) ? _c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.data), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "swiper-slide"
    }, [_c('a', {
      attrs: {
        "href": 'javascript:'
      }
    }, [_c('img', {
      attrs: {
        "src": item.image,
        "data-url": item.url,
        "data-id": item.id
      }
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })]) : _vm._e(), _vm._v(" "), (_vm.data.length === 1 && _vm.data[0]) ? _c('a', {
    attrs: {
      "href": 'javascript:'
    },
    on: {
      "click": function($event) {
        return _vm.onItem(_vm.data[0])
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.data[0].image
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ "eORg":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-chart"
  }, _vm._l((_vm.types), function(type) {
    return _c('chart', {
      key: type.code,
      attrs: {
        "name": type.name,
        "code": type.code
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),

/***/ "ha5f":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("E/y/")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("yILM"),
  /* template */
  __webpack_require__("CJMA"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b4a52d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "i2vQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_utils__ = __webpack_require__("j+bc");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__commons_utils__["c" /* dateFormat */]);

/***/ }),

/***/ "ijxf":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-chart__item"
  }, [_c('div', {
    staticClass: "ushk-chart__h"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "ushk-chart__b"
  }, [_c('div', {
    ref: "chartBody",
    class: {
      'is-empty': _vm.isEmpty
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ "j+bc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dateFormat; });
/* harmony export (immutable) */ __webpack_exports__["e"] = getQueryString;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isPC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return cookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return storage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return addClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return removeClass; });
/* unused harmony export hasClass */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return debounce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return flashFormat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_script__ = __webpack_require__("s92o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_script___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__plugins_script__);



var _this = this,
    _arguments = arguments;



var addCss = function addCss(url) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var node = document.createElement('link');
    node.rel = 'stylesheet';
    node.type = 'text/css';
    node.href = url;
    node.onload = function () {
      resolve();
    };
    document.getElementsByTagName('head')[0].appendChild(node);
  });
};

var addScript = function addScript(url, cb) {
  __WEBPACK_IMPORTED_MODULE_2__plugins_script___default()(url, cb);
  return __WEBPACK_IMPORTED_MODULE_2__plugins_script___default.a;
};

var dateFormat = function dateFormat(date, format) {
  if (typeof date === 'string' && date.indexOf('T') === -1) {
    date = date.replace(/-/g, '/');
  }
  if (typeof date === 'number') {
    if (date.toString().length === 10) {
      date *= 1000;
    }
  }
  date = new Date(date);
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return format;
};

var getWindowSize = function getWindowSize() {

  var pageWidth = window.innerWidth;
  var pageHeight = window.innerHeight;
  if (typeof pageWidth !== 'number') {
    if (document.compatMode == 'number') {
      pageWidth = document.documentElement.clientWidth;
      pageHeight = document.documentElement.clientHeight;
    } else {
      pageWidth = document.body.clientWidth;
      pageHeight = document.body.clientHeight;
    }
  }
  return { width: pageWidth > 1080 ? 1080 : pageWidth, height: pageHeight };
};

function getQueryString(name) {
  var getRequest = function getRequest() {
    var url = window.location.href;
    url = url.substr(url.indexOf('?'));
    var theRequest = new Object();
    if (url.indexOf('?') != -1) {
      var str = url.substr(1);
      var strs = str.split('&');
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1]);
      }
    }
    return theRequest;
  };
  return getRequest()[name];
}
var isPC = function isPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }

  if (flag) {
    flag = getWindowSize().width > 768;
  }
  return flag;
};

var getUrl = function getUrl(router, parms) {
  var isDev = "production" === 'development';
  var prex = isDev ? '/#/' + router : '//www.ushknews.com/' + router + '.html';

  if (!parms) {
    return prex;
  }
  if (isDev) {
    for (var key in parms) {
      var list = [];
      for (var key in parms) {
        list.push(parms[key]);
      }
      prex += '/' + list.join('/');
    }
  } else {
    var list = [];
    for (var key in parms) {
      list.push(key + '=' + parms[key]);
    }

    prex += '?' + list.join('&');
  }
  return prex;
};

var cookie = {
  set: function set(sName, sValue, sExpires, spath, sdomain, secure) {
    var sCookie = sName + '=' + encodeURIComponent(sValue);
    var date = new Date();
    date.setTime(date.getTime() + 3600 * 24 * 1000 * 365);
    sExpires = sExpires || date.toGMTString();
    if (sExpires != null) sCookie += '; expires=' + sExpires;
    if (spath != null) sCookie += '; path=' + spath;
    if (sdomain != null) sCookie += '; domain=' + sdomain;
    if (secure != null) sCookie += '; secure=' + secure;
    document.cookie = sCookie;
  },
  get: function get(sName) {
    var aCookie = document.cookie.split('; ');
    for (var i = 0; i < aCookie.length; i++) {
      var aCrumb = aCookie[i].split('=');
      if (sName === aCrumb[0]) return decodeURIComponent(aCrumb[1]);
    }
    return '';
  },
  remove: function remove(sName, spath, sdomain) {
    if (this.get(sName)) {
      document.cookie = sName + '=' + (spath ? ';path=' + spath : '') + (sdomain ? ';domain=' + sdomain : '') + ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
    }
  }
};

var storage = {
  get: function get(name) {
    var value = localStorage.getItem(name);
    if (!value) {
      return null;
    }
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  },
  set: function set(name, value) {
    localStorage.setItem(name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
  }
};

var addClass = function addClass(ele, cls) {
  if (ele.classList) {
    ele.classList.add(cls);
  } else if (!hasClass(ele, cls)) {
    ele.setAttribute('class', ele.getAttribute('class') + ' ' + cls);
  }
};

var removeClass = function removeClass(ele, cls) {
  if (ele.classList) {
    ele.classList.remove(cls);
  } else if (hasClass(ele, cls)) {
    ele.setAttribute('class', ele.getAttribute('class').replace(cls, ' '));
  }
};

var hasClass = function hasClass(ele, cls) {
  return ele.getAttribute('class').indexOf(cls) > -1;
};

var debounce = function debounce(func, delay) {
  var timer = null;
  return function () {
    var context = _this;
    var args = _arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      func.apply(context, args);
    }, delay);
  };
};

var replaceContentAndTrimHtml = function replaceContentAndTrimHtml(content, replaceStr) {
  var res = content.replace(replaceStr, '');
  if (res.startsWith('<b></b>')) {
    res = res.replace('<b></b>', '').trim();
  }
  if (res.startsWith('<br/>')) {
    res = res.replace('<br/>', '').trim();
  }
  return res;
};

var flashFormat = function flashFormat(item) {
  var reg = /^(<b>)?(【)(<b>)?(.+?)(<\/b>)?(】)(<\/b>)?/;
  var match = item.data.content.match(reg);
  var criticalValue = 6;
  if (match && match[0]) {
    if (!item.data.title) {
      if (match[4] && match[4].length >= criticalValue) {
        item.data.title = match[4];
        item.data.content = replaceContentAndTrimHtml(item.data.content, match[0]);
      }
    }

    if (match[4] && match[4].length < criticalValue) {
      item.data.tag = match[4];
      item.data.content = replaceContentAndTrimHtml(item.data.content, match[0]);
    }
  }
  var sourceLink = '';
  if (item.data.source) {
    if (item.data.source_link) {
      sourceLink = '<a class="flash-source cursor-pointer" href="' + item.data.source_link + '" target="__blank">\uFF08' + item.data.source + '\uFF09</a>';
    } else {
      sourceLink = '<a class="flash-source">\uFF08' + item.data.source + '\uFF09</a>';
    }
  }
  return item.data.content + sourceLink;
};

/***/ }),

/***/ "k+4S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mwBI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var Marquee3k = function () {
  function Marquee3k(element, options) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Marquee3k);

    this.element = element;
    this.options = options;
    this.selector = options.selector;
    this.speed = element.dataset.speed || 0.25;
    this.pausable = element.dataset.pausable;
    this.reverse = element.dataset.reverse;
    this.paused = false;
    this.isCustomContent = options.isCustomContent || false;
    this.parent = element.parentElement;
    this.parentProps = this.parent.getBoundingClientRect();
    this.content = element.children[0];
    this.innerContent = this.content.innerHTML;
    this.wrapStyles = '';
    this.offset = 0;
    this._setupWrapper();
    this._setupContent();
    this._setupEvents();
    if (!this.isCustomContent) {
      this.wrapper.appendChild(this.content);
      this.element.appendChild(this.wrapper);
    }
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Marquee3k, [{
    key: '_setupWrapper',
    value: function _setupWrapper() {
      if (this.isCustomContent) {
        this.wrapper = this.options.wrapper;
        return false;
      }
      this.wrapper = document.createElement('div');
      this.wrapper.classList.add('marquee3k__wrapper');
      this.wrapper.style.whiteSpace = 'nowrap';
    }
  }, {
    key: '_setupContent',
    value: function _setupContent() {
      this.contentWidth = this.content.offsetWidth;

      this.requiredReps = this.contentWidth > this.parentProps.width ? 2 : Math.ceil((this.parentProps.width - this.contentWidth) / this.contentWidth) + 1;
      if (!this.isCustomContent) {
        this.content.classList.add(this.selector + '__copy');
        this.content.style.display = 'inline-block';
        for (var i = 0; i < this.requiredReps; i++) {
          this._createClone();
        }
      }

      if (this.reverse) {
        this.offset = this.contentWidth * -1;
      }

      this.element.classList.add('is-init');
    }
  }, {
    key: '_setupEvents',
    value: function _setupEvents() {
      var _this = this;

      this.element.addEventListener('mouseenter', function () {
        if (_this.pausable) _this.paused = true;
      });

      this.element.addEventListener('mouseleave', function () {
        if (_this.pausable) _this.paused = false;
      });
    }
  }, {
    key: '_createClone',
    value: function _createClone() {
      var clone = this.content.cloneNode(true);
      clone.style.display = 'inline-block';
      clone.classList.add(this.selector + '__copy');
      this.wrapper.appendChild(clone);
    }
  }, {
    key: 'animate',
    value: function animate() {
      if (!this.paused) {
        var isScrolled = this.reverse ? this.offset < 0 : this.offset > this.contentWidth * -1;
        var direction = this.reverse ? -1 : 1;
        var reset = this.reverse ? this.contentWidth * -1 : 0;

        if (isScrolled) this.offset -= this.speed * direction;else this.offset = reset;

        this.wrapper.style.whiteSpace = 'nowrap';
        this.wrapper.style.transform = 'translate(' + this.offset + 'px, 0) translateZ(0)';
        this.options.callback({
          offset: this.offset,
          width: this.contentWidth
        });
      }
    }
  }, {
    key: '_refresh',
    value: function _refresh() {
      this.contentWidth = this.content.offsetWidth;
    }
  }, {
    key: 'repopulate',
    value: function repopulate(difference, isLarger) {
      this.contentWidth = this.content.offsetWidth;

      if (isLarger) {
        var amount = Math.ceil(difference / this.contentWidth) + 1;

        for (var i = 0; i < amount; i++) {
          this._createClone();
        }
      }
    }
  }], [{
    key: 'refresh',
    value: function refresh(index) {
      MARQUEES[index]._refresh();
    }
  }, {
    key: 'refreshAll',
    value: function refreshAll() {
      for (var i = 0; i < MARQUEES.length; i++) {
        MARQUEES[i]._refresh();
      }
    }
  }, {
    key: 'init',
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: 'marquee3k'
      };

      window.MARQUEES = [];
      var marquees = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.querySelectorAll('.' + options.selector));
      var previousWidth = window.innerWidth;
      var timer = void 0;

      for (var i = 0; i < marquees.length; i++) {
        var marquee = marquees[i];
        var instance = new Marquee3k(marquee, options);
        MARQUEES.push(instance);
      }

      animate();

      function animate() {
        for (var _i = 0; _i < MARQUEES.length; _i++) {
          MARQUEES[_i].animate();
        }
        window.requestAnimationFrame(animate);
      }

      window.addEventListener('resize', function () {
        clearTimeout(timer);

        timer = setTimeout(function () {
          var isLarger = previousWidth < window.innerWidth;
          var difference = window.innerWidth - previousWidth;

          for (var _i2 = 0; _i2 < MARQUEES.length; _i2++) {
            MARQUEES[_i2].repopulate(difference, isLarger);
          }

          previousWidth = _this2.innerWidth;
        });
      }, 250);
    }
  }]);

  return Marquee3k;
}();

/* harmony default export */ __webpack_exports__["a"] = (Marquee3k);

/***/ }),

/***/ "nKiP":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-backtop",
    class: {
      'is-show': _vm.isShow
    },
    on: {
      "click": _vm.backtop
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ushk-backtop__btn",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "ushk-icon ushk-icon_backtop"
  })])
}]}

/***/ }),

/***/ "nlLt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filterTrandByLoad */
/* unused harmony export filterTrandByChange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return genClassName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var filterTrandByLoad = function filterTrandByLoad(text, defaultG) {
  var evaluateClass = '';
  var g = defaultG ? parseInt(defaultG) : 1;
  if (text === '利多') {
    evaluateClass = 'liduo';
    if (g === 2) {
      evaluateClass = 'likong';
      text = '利空';
    }
  } else if (text === '利空') {
    evaluateClass = 'likong';
    if (g === 2) {
      evaluateClass = 'liduo';
      text = '利多';
    }
  } else if (text === '无影响') {
    text = '影响较小';
    evaluateClass = 'wuyingxiang';
  } else if (text === '利多2') {
    text = '利多';
    evaluateClass = 'liduo2';
    if (g === 2) {
      evaluateClass = 'likong2';
      text = '利空';
    }
  } else if (text === '利空2') {
    text = '利空';
    evaluateClass = 'likong2';
    if (g === 2) {
      evaluateClass = 'liduo2';
      text = '利多';
    }
  } else if (text === '无影响2') {
    text = '影响较小';
    evaluateClass = 'wuyingxiang2';
  }

  var rege = new RegExp('影响');
  if (rege.test(text)) {
    text = '影响较小';
  }
  return [evaluateClass, text];
};

var filterTrandByChange = function filterTrandByChange(text, trand) {
  var trands = [];
  if (trand === 'liduo') {
    trands.push('likong');
  } else if (trand === 'likong') {
    trands.push('liduo');
  } else if (trand === 'liduo2') {
    trands.push('likong2');
  } else if (trand === 'likong2') {
    trands.push('liduo2');
  }

  if (text === '利多') {
    trands.push('利空');
  } else if (text === '利空') {
    trands.push('利多');
  }
  return trands;
};

var genClassName = function genClassName(data, stockAffect) {
  var actual = data.actual,
      star = data.star,
      type = data.type,
      country = data.country,
      datanameId = data.datanameId,
      yingxiang = data.yingxiang,
      indicator_id = data.indicator_id;

  if (actual === null || actual === '') {
    return {
      statusClass: '',
      statusName: '未公布'
    };
  }
  var previous = data.previous && parseFloat(data.previous);
  var consensus = data.consensus && parseFloat(data.consensus);
  var id = datanameId || indicator_id;
  var num = consensus !== null ? consensus : previous;
  var important = star > 2;
  var affect = type === 0 && id ? 0 : typeof yingxiang !== 'undefined' ? yingxiang : data.affect;
  var liduoAffect = 0;
  var stockAffectLength = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(stockAffect).length;
  var curStockAffect = stockAffect[country];
  var name = '';
  if (type === 0 && stockAffectLength && curStockAffect && id) {
    if (curStockAffect.negative && curStockAffect.negative.indexOf(id) !== -1 || curStockAffect.positive && curStockAffect.positive.indexOf(id) === -1) {
      liduoAffect = 1;
    }
  }
  if (!num && num !== 0 || actual === num) {
    name = '无影响';
  } else {
    if (liduoAffect === affect) {
      name = actual > num ? '利多' : '利空';
    } else {
      name = actual > num ? '利空' : '利多';
    }
  }
  var evaluateArry = filterTrandByLoad(important ? name : name + '2');
  return {
    statusClass: evaluateArry[0],
    statusName: evaluateArry[1]
  };
};

/***/ }),

/***/ "s+38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_swiper__ = __webpack_require__("DNVT");





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    paddingTop: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      data: []
    };
  },
  mounted: function mounted() {
    this.render();
  },

  methods: {
    init: function init() {
      var self = this;
      new __WEBPACK_IMPORTED_MODULE_2_swiper__["a" /* default */]('.swiper-container', {
        loop: true,
        autoplay: {
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        on: {
          click: function click(e) {
            if (e.target.nodeName === 'IMG' && e.target.dataset) {
              self.onItem(e.target.dataset);
            }
          }
        }
      });
    },
    render: function render() {
      this.getData();
    },
    getData: function getData() {
      var _this = this;

      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__commons_fetch__["a" /* fetch */])({
          url: 'https://jad-api.ushknews.com/mult/list_unread',
          params: payload.params || {
            display: 'mgdx_index',
            fit_type: 'wide_image',
            page: 'main'
          },
          type: 'get',
          useJson: true,
          headers: {
            'x-version': '1.0.0',
            'x-app-id': '4PPkjw2SEyAhkTDB'
          },
          callback: function callback(res) {},
          success: function success(res) {
            var datas = res.data;
            if (!datas.length) {
              return false;
            }
            _this.data = datas;
            _this.$nextTick(function () {
              _this.init();
            });

            resolve(_this.data);
          },
          error: function error() {}
        });
      });
    },
    onItem: function onItem(item) {
      window.open(item.url);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__commons_fetch__["a" /* fetch */])({
          url: 'https://jad-api.ushknews.com/ad/ad_click_stat3',
          data: {
            ad_id: item.id
          },
          type: 'post',

          headers: {
            'x-version': '1.0.0',
            'x-app-id': '4PPkjw2SEyAhkTDB'
          },
          callback: function callback(res) {},
          success: function success(res) {
            console.log(res);
          },
          error: function error() {}
        });
      });
    }
  }
});

/***/ }),

/***/ "s92o":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition();else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else this[name] = definition();
})('$script', function () {
  var doc = document,
      head = doc.getElementsByTagName('head')[0],
      s = 'string',
      f = false,
      push = 'push',
      readyState = 'readyState',
      onreadystatechange = 'onreadystatechange',
      list = {},
      ids = {},
      delay = {},
      scripts = {},
      scriptpath,
      urlArgs;

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) {
      if (!fn(ar[i])) return f;
    }return 1;
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el);
      return 1;
    });
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths];
    var idOrDoneIsDone = idOrDone && idOrDone.call,
        done = idOrDoneIsDone ? idOrDone : optDone,
        id = idOrDoneIsDone ? paths.join('') : idOrDone,
        queue = paths.length;
    function loopFn(item) {
      return item.call ? item() : list[item];
    }
    function callback() {
      if (! --queue) {
        list[id] = 1;
        done && done();
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = []);
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback();

        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = path.indexOf('.js') === -1 ? scriptpath + path + '.js' : scriptpath + path;
        }

        if (scripts[path]) {
          if (id) ids[id] = 1;
          return scripts[path] == 2 ? callback() : setTimeout(function () {
            loading(path, true);
          }, 0);
        }

        scripts[path] = 1;
        if (id) ids[id] = 1;
        create(path, callback);
      });
    }, 0);
    return $script;
  }

  function create(path, fn) {
    var el = doc.createElement('script'),
        loaded;
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if (el[readyState] && !/^c|loade/.test(el[readyState]) || loaded) return;
      el.onload = el[onreadystatechange] = null;
      loaded = 1;
      scripts[path] = 2;
      fn();
    };
    el.async = 1;
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild);
  }

  $script.get = create;

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift();
      !scripts.length ? $script(s, id, done) : $script(s, callback);
    })();
  };

  $script.path = function (p) {
    scriptpath = p;
  };
  $script.urlArgs = function (str) {
    urlArgs = str;
  };
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps];
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {
      return list[dep];
    }) ? ready() : !function (key) {
      delay[key] = delay[key] || [];
      delay[key][push](ready);
      req && req(missing);
    }(deps.join('|'));
    return $script;
  };

  $script.done = function (idOrDone) {
    $script([null], idOrDone);
  };

  return $script;
});

/***/ }),

/***/ "teIl":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("HCTz"),
  /* template */
  __webpack_require__("d1Y1"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "uKUY":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qihuo-contract"
  }, [_c('p', {
    staticClass: "qihuo-contract-header"
  }, [_vm._v("商务合作")]), _vm._v(" "), _c('div', {
    staticClass: "qihuo-contract-body"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__("3Jun")
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__("MA7u")
    }
  })])])])
}]}

/***/ }),

/***/ "uWYQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_config__ = __webpack_require__("13m2");







var socketUrl = [];

var loaderSocket = function loaderSocket() {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (typeof io === 'undefined') {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons_utils__["a" /* addScript */])('//cdn.jin10.com/assets/js/plugins/socket.io.js', function () {
        resolve();
      });
    } else {
      resolve();
    }
  });
};

var SocketConnect = function () {
  function SocketConnect(options) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SocketConnect);

    var events = options ? options.events : {};

    this.instance = null;
    this.connection = null;
    this.urls = options && options.urls;

    this.events = {};
    events && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(events).forEach(function (name) {
      return _this.on(name, events[name]);
    });

    this.reConnectCount = 0;
    this.connectTimeout = 1000;
    this.failCount = 1;
    this.callback = options.callback;
    this.jsUrl = options.jsUrl;
    this.jsName = options.jsName;
    this.init();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SocketConnect, [{
    key: 'connect',
    value: function connect() {
      var _this2 = this;

      this.getUrl().then(function () {
        if (_this2.jsName) {
          socketUrl = window[_this2.jsName];
        }
        var serverURL = _this2.urls || (socketUrl.length ? socketUrl : __WEBPACK_IMPORTED_MODULE_5__commons_config__["a" /* requestUrl */].socket);
        if (Array.isArray(serverURL)) {
          var n = Math.floor(Math.random() * serverURL.length + 1) - 1;
          serverURL = serverURL[n];
        }
        var instance = null;
        _this2.instance = io.connect(serverURL, { 'force new connection': true, 'reconnection': false });
        instance = _this2.instance;
        instance.on('connect', function () {
          instance.emit('reg');
        });
        instance.on('error', function (reason) {
          _this2.reConnect('error');
        });

        instance.on('connect_error', function (reason) {
          _this2.reConnect('connect_error');
        });
        instance.on('repair', function (reason) {
          _this2.reConnect('repair');
        });
        instance.on('disconnect', function (reason) {
          if (reason !== 'io client disconnect') {
            _this2.reConnect('disconnect');
          }
        });
        _this2.callback && _this2.callback(instance);

        var _loop = function _loop(key) {
          instance.on(key, function (data) {
            var handlers = _this2.events[key];
            handlers.forEach(function (handler) {
              return handler(data);
            });
          });
        };

        for (var key in _this2.events) {
          _loop(key);
        }
      });
    }
  }, {
    key: 'emit',
    value: function emit(name, data, callback) {
      this.instance.emit(name, data, callback);
    }
  }, {
    key: 'on',
    value: function on(name, fn) {
      var handlers = this.events[name];
      if (handlers) {
        handlers.push(fn);
      } else {
        this.events[name] = [fn];
      }

      if (this.instance) {
        this.instance.on(name, fn);
      }
    }
  }, {
    key: 'off',
    value: function off(name, fn) {
      var handlers = this.events[name];
      if (handlers) {
        handlers.some(function (handler, index) {
          if (handler === fn) {
            return handlers.splice(index, 1);
          }
        });
      }
      if (this.instance) {
        this.instance.off(name, fn);
      }
    }
  }, {
    key: 'getUrl',
    value: function getUrl() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (_this3.jsUrl) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons_utils__["a" /* addScript */])(_this3.jsUrl + '?rnd=' + Math.random(), function (e) {
            resolve();
          });
        } else {
          resolve();
        }
      });
    }
  }, {
    key: 'reConnect',
    value: function reConnect(type) {
      var _this4 = this;

      if (this.reConnectCount >= 6 * this.failCount) {
        this.failCount = 2;
        if (this.connectTimeout >= 30000) {
          this.connectTimeout = 30000;
        } else {
          this.connectTimeout = this.connectTimeout * this.failCount;
        }
      }
      this.reConnectCount++;
      setTimeout(function () {
        _this4.instance.disconnect();
        setTimeout(function () {
          _this4.connect();
        }, 1);
      }, this.connectTimeout);
    }
  }, {
    key: 'init',
    value: function init() {
      var _this5 = this;

      this.connection = loaderSocket().then(function () {
        _this5.connect();
        return _this5;
      });
    }
  }]);

  return SocketConnect;
}();

/* harmony default export */ __webpack_exports__["a"] = (SocketConnect);

/***/ }),

/***/ "v1S1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_utils__ = __webpack_require__("j+bc");



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isShow: false
    };
  },
  mounted: function mounted() {
    document.addEventListener('scroll', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils__["g" /* debounce */])(this.scrollHandle, 10), false);
  },
  destroyed: function destroyed() {
    document.removeEventListener('scroll', this.scrollHandle, false);
  },

  methods: {
    scrollHandle: function scrollHandle() {
      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop > 200) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    backtop: function backtop() {
      var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
      var move = window.scrollY;
      var span = move / 15;

      function step() {
        if (document.documentElement.scrollTop + document.body.scrollTop > 0) {
          if (document.body.scrollTop) {
            document.body.scrollTop -= 300;
          } else {
            document.documentElement.scrollTop -= 300;
          }
          requestAnimationFrame(step);
        } else {}
      }

      requestAnimationFrame(step);
    }
  }
});

/***/ }),

/***/ "wY0R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x+d9":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("BOTu")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("/PmV"),
  /* template */
  __webpack_require__("Vx3l"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "xbG2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JinDatePicker_JinDatePickerPanel_vue__ = __webpack_require__("J+Zw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JinDatePicker_JinDatePickerPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__JinDatePicker_JinDatePickerPanel_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UshkDatepicker',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    name: String,
    placeholder: String,
    val: String,
    value: {},
    className: String
  },

  components: {
    JinDatePickerPanel: __WEBPACK_IMPORTED_MODULE_0__JinDatePicker_JinDatePickerPanel_vue___default.a
  },

  data: function data() {
    return {
      datePickerPanelShow: false,
      interVal: this.value,
      flatPickr: null
    };
  },


  computed: {
    dateValueText: function dateValueText() {
      return (this.value || new Date()).format('yyyy年MM月');
    },
    mobileDateValueText: function mobileDateValueText() {
      return (this.value || new Date()).format('yyyy-MM-dd');
    },
    notToday: function notToday() {
      return (this.value || new Date()).format('yyyyMMdd') !== new Date().format('yyyyMMdd');
    }
  },

  methods: {
    backToday: function backToday() {
      this.$emit('input', new Date());
    },
    onDatePick: function onDatePick() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var date = param.date;

      this.$emit('input', date);
    },
    onDatePickerOpen: function onDatePickerOpen() {
      this.updatePickerSelectedDate();
    },
    updatePickerSelectedDate: function updatePickerSelectedDate() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.datePickerPanel && _this.$refs.datePickerPanel.setDate(_this.value);
      });
    },
    handleTriggerDate: function handleTriggerDate() {
      this.datePickerPanelShow = !this.datePickerPanelShow;
    },
    onClosePicker: function onClosePicker() {
      this.datePickerPanelShow = false;
    }
  }
});

/***/ }),

/***/ "yILM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__ = __webpack_require__("8Yka");




var _WEEKS = ['日', '一', '二', '三', '四', '五', '六'];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'JinDateTable',
  props: {
    firstDayOfWeek: {
      type: Number,
      default: 1,
      validator: function validator(val) {
        return val >= 1 && val <= 7;
      }
    },
    activeTab: String,
    date: {},
    disabledDate: {},
    selectionMode: {
      default: 'day'
    },
    daterange: {
      type: Object,
      default: function _default() {
        return {
          start: '',
          end: ''
        };
      }
    },
    initDate: {
      type: Date,
      default: function _default() {
        return this.date;
      }
    }
  },
  data: function data() {
    return {
      tableRows: [[], [], [], [], [], []]
    };
  },

  computed: {
    offsetDay: function offsetDay() {
      var week = this.firstDayOfWeek;

      return week > 3 ? 7 - week : -week;
    },
    WEEKS: function WEEKS() {
      var week = this.firstDayOfWeek;
      return _WEEKS.concat(_WEEKS).slice(week, week + 7);
    },
    year: function year() {
      return this.date.getFullYear();
    },
    month: function month() {
      return this.date.getMonth();
    },
    week: function week() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["a" /* getWeekNumber */])(this.date);
    },
    startDate: function startDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["k" /* getStartDateOfMonth */])(this.year, this.month);
    },
    rows: function rows() {
      var _this = this;

      var date = new Date(this.year, this.month, 1);
      var day = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["l" /* getFirstDayOfMonth */])(date);
      var dateCountOfMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["m" /* getDayCountOfMonth */])(date.getFullYear(), date.getMonth());
      var dateCountOfLastMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["m" /* getDayCountOfMonth */])(date.getFullYear(), date.getMonth() === 0 ? 11 : date.getMonth() - 1);

      day = day === 0 ? 7 : day;

      var offset = this.offsetDay;
      var rows = this.tableRows;
      var count = 1;

      var startDate = this.startDate;
      var disabledDate = this.disabledDate;
      var cellClassName = this.cellClassName;
      var selectedDate = this.selectionMode === 'dates' ? [this.value] : [];
      var now = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["n" /* getDateTimestamp */])(new Date());

      for (var i = 0; i < 6; i++) {
        var row = rows[i];

        var _loop = function _loop(j) {
          var cell = row[j];
          if (!cell) {
            cell = { row: i, column: j, type: 'normal' };
          }

          cell.type = 'normal';

          var index = i * 7 + j;
          var time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["h" /* nextDate */])(startDate, index - offset).getTime();

          var isToday = time === now;

          if (isToday) {
            cell.type = 'today';
          }

          if (i >= 0 && i <= 1) {
            var numberOfDaysFromPreviousMonth = day + offset < 0 ? 7 + day + offset : day + offset;

            if (j + i * 7 >= numberOfDaysFromPreviousMonth) {
              cell.text = count++;
            } else {
              cell.text = dateCountOfLastMonth - (numberOfDaysFromPreviousMonth - j % 7) + 1 + i * 7;
              cell.type = 'prev-month';
            }
          } else if (count <= dateCountOfMonth) {
            cell.text = count++;
          } else {
            cell.text = count++ - dateCountOfMonth;
            cell.type = 'next-month';
          }

          var cellDate = new Date(time);
          cell.disabled = typeof disabledDate === 'function' && disabledDate(cellDate);
          cell.selected = selectedDate.find(function (date) {
            return date.getTime() === cellDate.getTime();
          });
          cell.customClass = typeof cellClassName === 'function' && cellClassName(cellDate);
          _this.$set(row, j, cell);
        };

        for (var j = 0; j < 7; j++) {
          _loop(j);
        }
      }

      return rows;
    }
  },
  methods: {
    cellMatchesDate: function cellMatchesDate(cell, date) {
      var value = new Date(date);
      return this.year === value.getFullYear() && this.month === value.getMonth() && Number(cell.text) === value.getDate();
    },
    getCellClasses: function getCellClasses(cell) {
      var selectionMode = this.selectionMode;

      var classes = [];
      var row = cell.row,
          column = cell.column;

      var newDate = this.getDateOfCell(row, column);

      if ((cell.type === 'normal' || cell.type === 'today') && !cell.disabled) {
        classes.push('avaliable');
      }
      if (selectionMode === 'day' && (cell.type === 'normal' || cell.type === 'today') && this.cellMatchesDate(cell, this.initDate)) {
        classes.push('current');
      }
      if (selectionMode === 'week') {
        var week = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["a" /* getWeekNumber */])(newDate);
        if (week === this.week) {
          classes.push('in-weekrange');
        }
        if (cell.column === 0) {
          classes.push('start-week-day');
        }
        if (cell.column === 6) {
          classes.push('end-week-day');
        }
      }
      if (selectionMode === 'range') {
        var _daterange = this.daterange,
            start = _daterange.start,
            end = _daterange.end;

        if (start && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["o" /* getDayTimestamp */])(newDate) === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["o" /* getDayTimestamp */])(start)) {
          classes.push('current', 'range-start');
        }
        if (end && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["o" /* getDayTimestamp */])(newDate) === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["o" /* getDayTimestamp */])(end)) {
          classes.push('current', 'range-end');
        }

        if (start && !end) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["o" /* getDayTimestamp */])(newDate) >= __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["o" /* getDayTimestamp */])(start)) {
            classes.push('in-range');
          }
        } else if (end && !start) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["o" /* getDayTimestamp */])(newDate) <= __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["o" /* getDayTimestamp */])(end)) {
            classes.push('in-range');
          }
        } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["o" /* getDayTimestamp */])(newDate) >= __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["o" /* getDayTimestamp */])(start) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["o" /* getDayTimestamp */])(newDate) <= __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["o" /* getDayTimestamp */])(end)) {
          classes.push('in-range');
        }
      }
      if (cell.type === 'today') {
        classes.push('today');
      }
      return classes.join(' ');
    },
    handleClick: function handleClick(event) {
      var target = event.target;
      if (target.tagName === 'SPAN') {
        target = target.parentNode.parentNode;
      }
      if (target.tagName === 'DIV') {
        target = target.parentNode;
      }

      if (target.tagName !== 'TD') {
        return;
      }

      var row = target.parentNode.rowIndex - 1;
      var column = this.selectionMode === 'week' ? 0 : target.cellIndex;

      var newDate = this.getDateOfCell(row, column);

      if (this.selectionMode === 'day' || this.selectionMode === 'week') {
        this.$emit('pick', Number(newDate));
      }
      if (this.selectionMode === 'range') {
        if (this.activeTab === 'start') {
          this.$emit('start-pick', newDate);
        } else {
          this.$emit('end-pick', newDate);
        }
      }
    },
    getDateOfCell: function getDateOfCell(row, column) {
      var offsetFromStart = row * 7 + column - this.offsetDay;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["h" /* nextDate */])(this.startDate, offsetFromStart);
    }
  }
});

/***/ }),

/***/ "yR7j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonp__ = __webpack_require__("hU7x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);






var CancelToken = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken;

var msgFiltering = function msgFiltering(datas) {
  var errors = datas.errors;
  var messages = [];

  if ((typeof errors === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(errors)) === 'object' && !Array.isArray(errors) && errors !== null) {
    for (var name in errors) {
      messages.push(errors[name]);
    }
    return messages;
  } else {
    return datas.message;
  }
};

var tips = function tips(message, type) {
  __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$tips({
    message: message,
    type: type
  });
};

var myAxios = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  withCredentials: true
});

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.withCredentials = true;

var fetch = function fetch(_ref) {
  var type = _ref.type,
      params = _ref.params,
      data = _ref.data,
      url = _ref.url,
      useJson = _ref.useJson,
      success = _ref.success,
      fail = _ref.fail,
      error = _ref.error,
      callback = _ref.callback,
      showError = _ref.showError,
      jsonpCallback = _ref.jsonpCallback,
      headers = _ref.headers;

  params = params || '';
  showError = typeof showError === 'undefined' ? true : showError;
  if (type === 'jsonp') {
    var datas = [];
    if (params && (typeof params === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(params)) === 'object') {
      for (var key in params) {
        datas.push(key + '=' + params[key]);
      }
      datas = datas.join('&');
    }
    var s = '?';
    if (url.indexOf(s) !== -1) {
      s = '&';
    }
    __WEBPACK_IMPORTED_MODULE_2_jsonp___default()(url + s + datas, {
      param: jsonpCallback || 'callback'
    }, function (err, response) {
      callback && callback(response);
      if (err) {
        error && error();
        if (showError) {
          tips('请求错误', 'error');
        }
        return false;
      }
      if (response.status_code !== 200) {
        fail && fail(response);
        if (showError) {
          tips(response.message || '请求错误', 'error');
        }
        return false;
      }
      success && success(response);
    });
  } else {
    if (!useJson) {
      params = __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(params);
    }
    var source = CancelToken.source();
    var promise = void 0;
    if (type === 'get') {
      promise = myAxios({
        method: type,
        url: url,
        params: params,
        cancelToken: source.token,
        headers: headers
      });
    } else {
      promise = myAxios({
        method: type,
        url: url,
        data: data,
        cancelToken: source.token,
        headers: headers
      });
    }

    promise.then(function (response) {
      response = response.data;
      callback && callback(response);
      if (response.status_code && response.status_code !== 200 || response.status && response.status !== 200) {
        var msg = msgFiltering(response);
        msg = Array.isArray(msg) ? msg.join('，') : msg;
        if (fail) {
          fail(response, msg);
        }
        if (showError) {
          tips(msg || '请求错误', 'error');
        }
        return false;
      }
      success && success(response);
    }).catch(function (e) {
      var message = e && e.message ? e.message : '请求错误';
      console.log(message);
      error && error();
    });
    promise.$cancel = source.cancel;
    return promise;
  }
};

/***/ }),

/***/ "zmdZ":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Kg+A"),
  /* template */
  __webpack_require__("aehN"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/commons.04445160704adff149a6.js